import React from "react";

import { AVAILABLE_LANGS } from "@typings/globals";

import { setLanguageInUrl } from "@services/SetLanguageInUrl";

import { useTelemetry } from "@hooks/useTelemetry";
import { useTranslate } from "@hooks/useTranslate";
import { useLocalisation } from "@hooks/useLocalisation";
import { useConfig } from "@hooks/useConfig";

import { Link, ClickHandler } from "./useLangNav.types";
import { linksConfig } from "./useLangNav.helpers";

export const useLangNav = () => {
  const translate = useTranslate();
  const { setLanguage } = useLocalisation();
  const { elementClick } = useTelemetry();

  const availableLanguages = useConfig<AVAILABLE_LANGS[]>([
    "availableLanguages",
  ]);

  const clickHandler: (
    lang: AVAILABLE_LANGS,
    buttonId?: string,
  ) => ClickHandler = (lang, buttonId) => event => {
    event.preventDefault();

    elementClick(event.currentTarget.textContent || "", {
      buttonId,
    });

    setLanguageInUrl(lang);
    setLanguage(lang);
  };

  const links: Link[] = availableLanguages.map(lang => {
    const { label, ...config } = linksConfig[lang];

    return {
      ...config,
      label: translate(label),
      href: `/${lang.toLowerCase()}/`,
      clickHandler: clickHandler(lang, config.eventId),
    };
  });
  const getActiveLink = (language: AVAILABLE_LANGS) =>
    links.find(link => link.code === language)!;

  return {
    links,
    getActiveLink,
  };
};
